module.exports = __webpack_public_path__ + "static/media/grid-image6.489f4ba7.jpg";